import Lottie from "lottie-react";

const SFLottieAnimation = (props) => {
  const { animationData, loop } = props;
  return (
    <Lottie
      animationData={animationData}
      loop={loop}
    />
  );
};

export default SFLottieAnimation;
